import { useEffect, useRef } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Lenis from 'lenis';
import { Toaster } from '@/components/ui/sonner';
import '@/App.css';

import Header from '@/components/Header';
import Footer from '@/components/Footer';
import StickyCallBar from '@/components/StickyCallBar';
import Home from '@/pages/Home';
import ServicePage from '@/pages/ServicePage';
import CityPage from '@/pages/CityPage';
import ServiceAreas from '@/pages/ServiceAreas';
import About from '@/pages/About';
import Contact from '@/pages/Contact';
import AdminLogin from '@/pages/AdminLogin';
import AdminDashboard from '@/pages/AdminDashboard';
import Gallery from '@/pages/Gallery';
import Products from '@/pages/Products';
import { CITIES, cityPath } from '@/data/site';

const Layout = ({ children }) => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith('/admin');
  if (isAdmin) return children;
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
      <StickyCallBar />
      <div className="h-20 md:hidden" aria-hidden="true" />
    </>
  );
};

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager lenisRef={lenisRef} />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/heating-air-conditioning" element={<ServicePage />} />
            <Route path="/air-conditioning-repair-stanfield-nc" element={<ServicePage />} />
            <Route path="/air-conditioning-installation-stanfield-nc" element={<ServicePage />} />
            <Route path="/heating-repair-installation-stanfield-nc" element={<ServicePage />} />
            <Route path="/plumbing" element={<ServicePage />} />
            <Route path="/excavation-trenching" element={<ServicePage />} />
            <Route path="/indoor-air-quality" element={<ServicePage />} />
            <Route path="/financing" element={<ServicePage />} />
            <Route path="/promotions" element={<ServicePage />} />
            <Route path="/service-areas" element={<ServiceAreas />} />
            {CITIES.map((c) => (
              <Route key={c.slug} path={cityPath(c.slug)} element={<CityPage citySlug={c.slug} />} />
            ))}
            <Route path="/about" element={<About />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/products" element={<Products />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </Layout>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

const ScrollManager = ({ lenisRef }) => {
  const { pathname } = useLocation();
  useEffect(() => {
    lenisRef.current?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname, lenisRef]);
  return null;
};

export default App;
